import React from "react";
import {Route, Switch, withRouter, Redirect} from "react-router-dom";
import MainLayout from "./layouts/MainLayout";
import WorldCurrency from "./components/WorldCurrency";
import TradingCulcPage from "./components/TradingCulcPage";
import MarginCalculator from "./components/MarginCalculator";
import ProfitLossCalculator from "./components/ProfitLossCalculator";
import NotFound from "./components/NotFound";
import { isValidFiatPair, isValidCryptoPair, isValidAmount, currensys } from "./helpers/constants";
import {
    MAIN_ROUTE,
    SUPPORTED_LANGUAGES,
    CALCULATOR_ROUTE,
    CURRENCY_ROUTE,
    MARGIN_ROUTE,
    PROFIT_LOSS_ROUTE,
    MAIN_ROUTE_BY_LANGUAGE,
    MAIN_ROUTE_WITH_LANGUAGE_AND_CURRENCIES,
    MAIN_ROUTE_WITH_LANGUAGE_AND_CURRENCIES_AND_AMOUT,
    MAIN_ROUTE_WITH_LANGUAGE_AND_CURRENCIES_CRYPTO,
    MAIN_ROUTE_WITH_LANGUAGE_AND_CURRENCIES_AND_AMOUNT_CRYPTO,
    CRYPTO_ROUTE,
    LANDING_ROUTE,
    LANDING_ROUTE_WITH_LANGUAGE_AND_CURRENCIES,
    LANDING_ROUTE_WITH_LANGUAGE_AND_CURRENCIES_AND_AMOUNT
} from "./helpers/constants";
import {translate} from "react-i18next";
import {connect} from "react-redux";
import DashBoard from "./components/DashBoard";
import DashBoardCrypto from "./components/DashBoardCrypto";
import DashBoardLanding from "./components/DashBoardLanding";

const mg_category_select = [
    {
        value: "forex",
        name: "Currency Pairs"
    },
    {
        value: "indices",
        name: "Indices"
    },
    {
        value: "commodities",
        name: "Commodities"
    },
    {
        value: "stocks",
        name: "Stocks"
    },
    {
        value: "precious-metals",
        name: "Precious Metals"
    },
    {
        value: "gold-trading",
        name: "Gold Instruments"
    },
    {
        value: "personal-instrument-pci",
        name: "PCI Library"
    },
    {
        value: "cfd-etf",
        name: "ETF"
    }
];

class Routes extends React.Component{

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return false
    }

    render(){

        return (
            <MainLayout>
                <Switch>
                    <Route exact path={MAIN_ROUTE} render={() => {
                        const browserLang = (navigator.language || "en").slice(0, 2).toLowerCase();
                        if(browserLang !== "en" && SUPPORTED_LANGUAGES.includes(browserLang)){
                            return <Redirect to={`/${browserLang}`} />;
                        }
                        return <DashBoard/>;
                    }} />
                    <Route exact path={MAIN_ROUTE_BY_LANGUAGE} component={DashBoard} />
                    <Route exact path={CRYPTO_ROUTE} component={DashBoardCrypto} />
                    <Route exact path={LANDING_ROUTE} component={DashBoardLanding} />
                    <Route exact path={CALCULATOR_ROUTE} component={TradingCulcPage} />
                    <Route exact path={MAIN_ROUTE_WITH_LANGUAGE_AND_CURRENCIES_CRYPTO} render={({match}) => (
                        isValidCryptoPair(match.params.curencies) ? <DashBoardCrypto/> : <NotFound/>
                    )} />
                    <Route exact path={MAIN_ROUTE_WITH_LANGUAGE_AND_CURRENCIES_AND_AMOUNT_CRYPTO} render={({match}) => {
                        const {curencies, amount} = match.params;
                        return (isValidCryptoPair(curencies) && isValidAmount(amount)) ? <DashBoardCrypto/> : <NotFound/>;
                    }} />
                    <Route exact path={LANDING_ROUTE_WITH_LANGUAGE_AND_CURRENCIES} component={DashBoardLanding} />
                    <Route exact path={LANDING_ROUTE_WITH_LANGUAGE_AND_CURRENCIES_AND_AMOUNT} component={DashBoardLanding} />

                    <Route path={MAIN_ROUTE_WITH_LANGUAGE_AND_CURRENCIES} exact render={({match}) => {
                        const {curencies} = match.params;
                        const pathname = this.props.location.pathname;
                        if(pathname.includes("forex") || pathname.includes("currencies")){
                            return <WorldCurrency/>
                        } else if(isValidFiatPair(curencies)){
                            return <DashBoard/>
                        } else {
                            return <NotFound/>;
                        }
                    }} />
                    <Route exact path={MAIN_ROUTE_WITH_LANGUAGE_AND_CURRENCIES_AND_AMOUT} render={({match}) => {
                        const {curencies, amount} = match.params;
                        const pathname = this.props.location.pathname;
                        if(pathname.includes("forex-calculator/profitloss-calculation")){
                            return <ProfitLossCalculator/>
                        } else if(pathname.includes("forex-calculator/margin-calculation")){
                            return <MarginCalculator/>
                        } else if(isValidFiatPair(curencies) && isValidAmount(amount)){
                            return <DashBoard/>
                        } else {
                            return <NotFound/>;
                        }
                    }} />
                    <Route exact path={CURRENCY_ROUTE} component={WorldCurrency} />
                    <Route exact path={PROFIT_LOSS_ROUTE}
                           component={() => <ProfitLossCalculator mg_category_select={mg_category_select}
                                                                  currensys={currensys} />}
                    />
                    <Route exact path={MARGIN_ROUTE}
                           component={() => <MarginCalculator mg_category_select={mg_category_select}
                                                              currensys={currensys} />}
                    />
                    <Route component={() => <NotFound/>} />
                </Switch>
            </MainLayout>);
    }
}
export default connect(
    state => ({
        language: state.language

    })
)(translate('common')(withRouter(Routes)))